import { Icon } from '@iconify/vue'
import { createVuetify } from 'vuetify'

import { themes } from '@/themes'

import 'vuetify/styles'

export default createVuetify({
  display: {
    mobileBreakpoint: 'xs'
  },
  icons: {
    defaultSet: 'iconify',
    sets: {
      iconify: { component: Icon as any }
    }
  },
  theme: {
    defaultTheme: 'salto',
    themes: themes
  },
})
